import React from 'react';
import { Table } from '../../../UiKit';
import { EmptyState } from '../../commons';
import { InvalidSearchImg } from '../../../images/images';
import './BatchedDetails.scss';

const tableHeadings = [
  { name: 'Order ID', key: 1 },
  { name: 'Drop Sequence', key: 2 },
  { name: 'Order Type', key: 3 },
  { name: 'Order Status', key: 4 },
];

const getTableRows = (details) => {
  const rowsData = [];
  details &&
    details.map((item) => {
      const rowObj = {
        1: {
          title: item.order_id ? (
            <div
              role='button'
              tabIndex={0}
              style={{
                cursor: 'pointer',
              }}
              onClick={() => {
                window.open(
                  `/lifeline?type=order_id&value=${item.order_id}`,
                  '_blank',
                );
                return;
              }}
            >
              <span>{item.order_id || '-'}</span>
              {item.is_selected_order && <span className='red-star'>*</span>}
            </div>
          ) : (
            '-'
          ),
        },
        2: {
          title: item.sequence || '-',
        },
        3: {
          title: item.type_tag.text ? (
            <div
              style={{
                background: item.type_tag.bg_color,
                color: item.type_tag.color,
                padding: '2px 4px',
                borderRadius: '5px',
              }}
            >
              {item.type_tag.text}
            </div>
          ) : (
            '-'
          ),
        },
        4: {
          title: item.status_tag.text ? (
            <div
              style={{
                background: item.status_tag.bg_color,
                color: item.status_tag.color,
                padding: '2px 4px',
                borderRadius: '5px',
              }}
            >
              {item.status_tag.text}
            </div>
          ) : (
            '-'
          ),
        },
      };
      rowsData.push(rowObj);
      return true;
    });
  return rowsData;
};

const getTableData = (details) => {
  const tableData = {
    headings: tableHeadings,
    rows: getTableRows(details),
  };
  return tableData;
};

export const BatchedDetails = ({ details }) => {
  return (
    <div className='modalContent'>
      {!details ? (
        <EmptyState
          img={InvalidSearchImg}
          heading='No data available!'
          isPop={true}
        />
      ) : (
        <div className='batchedDetails'>
          <Table tableData={getTableData(details)} />
          <div className='footerHint'>
            <span className='footerHintText'>
              <span className='red-star'>*</span> represents current order
            </span>
          </div>
        </div>
      )}
    </div>
  );
};
